var _path, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m183.318 66.679h301.867c8.729 0 15.815 7.087 15.815 15.815v402.69c0 8.729-7.087 15.816-15.816 15.816h-301.866c-8.729 0-15.815-7.087-15.815-15.815v-402.691c0-8.729 7.087-15.815 15.815-15.815z",
    fill: "#8a96bf"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m167.503 485.185v-320.487c0-6.805 2.426-12.661 7.238-17.472l73.31-73.309c4.812-4.812 10.668-7.237 17.472-7.237h219.662c5.508 0 10 4.492 10 10v406.505c0 6.609-5.391 12-12 12h-305.682c-5.506 0-10-4.492-10-10z",
    fill: "#a8b4db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.824 429.506v-320.487c0-6.805 2.426-12.661 7.237-17.472l73.31-73.31c4.811-4.812 10.668-7.237 17.472-7.237h219.662c8.711 0 15.816 7.105 15.816 15.815v402.691c0 8.711-7.105 15.815-15.816 15.815h-301.866c-8.711 0-15.816-7.104-15.816-15.815z",
    fill: "#8a96bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.824 429.506v-320.487c0-6.805 2.426-12.661 7.237-17.472l73.31-73.31c4.812-4.811 10.668-7.237 17.472-7.237h219.662c5.508 0 10 4.492 10 10v406.506c0 6.609-5.391 12-12 12h-305.681c-5.506 0-10-4.492-10-10z",
    fill: "#d2dbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.371 18.237c4.811-4.812 10.668-7.237 17.472-7.237h6.272c-8.989 3.709-15.359 12.579-15.359 22.867v50.254c0 8.709-7.103 15.813-15.812 15.813h-50.254c-10.286 0-19.158 6.369-22.867 15.359v-6.272c0-6.805 2.426-12.661 7.237-17.472z",
    fill: "#8a96bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.371 18.237c4.811-4.812 10.668-7.237 17.472-7.237h6.272c-7.646 1.416-20.757 8.732-20.757 22.867v50.254c0 5.73-4.685 10.415-10.414 10.415h-50.254c-6.807 0-18.704 2.786-22.867 20.757v-6.272c0-6.805 2.426-12.661 7.237-17.472z",
    fill: "#a8b4db"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m26.815 231.711h347.011c8.729 0 15.816 7.087 15.816 15.816v126.3c0 8.729-7.086 15.815-15.815 15.815h-347.011c-8.729 0-15.816-7.087-15.816-15.816v-126.3c0-8.729 7.087-15.815 15.815-15.815z",
    fill: "#3254d1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.465 377.631c-.303-1.219-.465-2.493-.465-3.804v-126.299c0-8.711 7.104-15.816 15.815-15.816h340.815c5.508 0 10 4.492 10 10v123.919c0 6.608-5.392 12-12 12z",
    fill: "#4370ff",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m267.533 310.679c0 15.291 12.444 27.729 27.729 27.729 7.412 0 14.372-2.886 19.61-8.124 3.122-3.122 8.192-3.122 11.315 0 3.127 3.127 3.127 8.188 0 11.314-8.261 8.256-19.242 12.807-30.925 12.807-24.107 0-43.726-19.615-43.726-43.726s19.62-43.731 43.726-43.731c11.682 0 22.663 4.55 30.925 12.812 3.127 3.122 3.127 8.188 0 11.309-3.122 3.127-8.193 3.127-11.315 0-5.238-5.237-12.198-8.119-19.61-8.119-15.285 0-27.729 12.438-27.729 27.729zm-67.366 27.729c-15.291 0-27.734-12.438-27.734-27.734s12.443-27.724 27.734-27.724 27.729 12.438 27.729 27.724-12.443 27.734-27.729 27.734zm0-71.46c-24.121 0-43.731 19.615-43.731 43.726s19.61 43.731 43.731 43.731 43.726-19.615 43.726-43.731-19.62-43.726-43.726-43.726zm-95.11 71.46h-16.93v-55.458h16.93c15.291 0 27.729 12.438 27.729 27.724s-12.438 27.734-27.729 27.734zm0-71.46h-24.931c-4.418 0-8.001 3.584-8.001 8.001v71.46c0 4.418 3.583 7.996 8.001 7.996h24.931c24.111 0 43.726-19.615 43.726-43.731s-19.615-43.726-43.726-43.726z",
    fill: "#edeff3",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.080f9cc9ba2ab20e64656277c96df670.svg";
export { ForwardRef as ReactComponent };